var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconLock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.99997 2.86816C5.8954 2.86816 4.99997 3.76359 4.99997 4.86816V5.86816H8.99997V4.86816C8.99997 3.76359 8.10454 2.86816 6.99997 2.86816ZM2.99997 4.86816V5.86816C2.17156 5.86818 1.5 6.53975 1.5 7.36816V13.3682C1.5 14.1966 2.17157 14.8682 3 14.8682H11C11.8284 14.8682 12.5 14.1966 12.5 13.3682V7.36816C12.5 6.53974 11.8284 5.86816 11 5.86816H11V4.86816C11 2.65903 9.20911 0.868164 6.99997 0.868164C4.79083 0.868164 2.99997 2.65902 2.99997 4.86816ZM7 11.6182C7.69036 11.6182 8.25 11.0585 8.25 10.3682C8.25 9.67781 7.69036 9.11816 7 9.11816C6.30964 9.11816 5.75 9.67781 5.75 10.3682C5.75 11.0585 6.30964 11.6182 7 11.6182Z",
    fill: "#0C266C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLock);
export default __webpack_public_path__ + "static/media/iconLock.bae43b899795aa06bce16405d7d134cd.svg";
export { ForwardRef as ReactComponent };